<div>
  <div *ngFor="let purchase of planPurchases"
       sxPadding="medium" sxBackground="light" sxRow sxRadius="medium"
  sxAlign="center" sxGap="10px"
  >
    <div>
      <h3 sxMargin="0">{{purchase?.plan?.name}}</h3>
      <p>{{purchase?.planPricingModel?.validityDays}}</p>
    </div>
    <p sxTextSize="small" sxColor="two">Valid Till {{purchase?.expireTime | date : 'mediumDate'}}</p>

  </div>
</div>
